export default __webpack_public_path__ + "static/ritual_face_1-b481eea1cf78c22bd3fe0816bfb24531.svg";